import { COMMUNITY_PLAN_PRODUCT_ID, PLUS_PLAN_PRODUCT_ID, TEAM_PLAN_PRODUCT_ID } from '../../constants'
import { BillingApiClient } from '../../services'
import type { BillingVersion } from '../../types'
import type { PlanId, PlanSummary } from '../types'

export const getLegacyPlanSummary = async (
  workspaceId: string,
  planId: PlanId,
  billingVersion: BillingVersion
): Promise<PlanSummary> => {
  const productId = getProductIdForPlanId(planId, billingVersion)
  if (!productId) {
    return { id: planId, monthlyPriceDollars: undefined }
  }

  const products = await BillingApiClient.getBillingProducts(workspaceId)
  const product = products.find((p) => p.id === productId)
  if (!product?.prices?.length) {
    return { id: planId, monthlyPriceDollars: undefined }
  }

  const monthlyPrice = product.prices.find((price) => price.recurring?.interval === 'month')
  const yearlyPrice = product.prices.find((price) => price.recurring?.interval === 'year')
  const cents = monthlyPrice?.unit_amount ?? (yearlyPrice ? Math.round((yearlyPrice.unit_amount ?? 0) / 12) : undefined)
  const monthlyPriceDollars = cents != null ? cents / 100 : undefined

  return { id: planId, monthlyPriceDollars }
}

const getProductIdForPlanId = (planId: PlanId, billingVersion: string): string | undefined => {
  if (planId === 'community') return COMMUNITY_PLAN_PRODUCT_ID
  if (planId === 'team') return TEAM_PLAN_PRODUCT_ID
  if (planId === 'enterprise') return undefined
  if (planId === 'managed') return undefined
  if (planId === 'plus') return billingVersion === 'v3' ? PLUS_PLAN_PRODUCT_ID : TEAM_PLAN_PRODUCT_ID
  return undefined
}
